// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICategorySpendLimitRenewalDto
 */
export interface ICategorySpendLimitRenewalDto {
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitRenewalDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitRenewalDto
     */
    coverage_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICategorySpendLimitRenewalDto
     */
    category_type?: ICategorySpendLimitRenewalDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICategorySpendLimitRenewalDto
     */
    category_spend_limit?: number;
}

/**
* @export
* @enum {string}
*/
export enum ICategorySpendLimitRenewalDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the ICategorySpendLimitRenewalDto interface.
 */
export function instanceOfICategorySpendLimitRenewalDto(value: object): value is ICategorySpendLimitRenewalDto {
    return true;
}

export function ICategorySpendLimitRenewalDtoFromJSON(json: any): ICategorySpendLimitRenewalDto {
    return ICategorySpendLimitRenewalDtoFromJSONTyped(json, false);
}

export function ICategorySpendLimitRenewalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategorySpendLimitRenewalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'coverage_id': json['coverage_id'] == null ? undefined : json['coverage_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'category_spend_limit': json['category_spend_limit'] == null ? undefined : json['category_spend_limit'],
    };
}

export function ICategorySpendLimitRenewalDtoToJSON(json: any): ICategorySpendLimitRenewalDto {
    return ICategorySpendLimitRenewalDtoToJSONTyped(json, false);
}

export function ICategorySpendLimitRenewalDtoToJSONTyped(value?: ICategorySpendLimitRenewalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'coverage_id': value['coverage_id'],
        'category_type': value['category_type'],
        'category_spend_limit': value['category_spend_limit'],
    };
}

